export const sections = [
	'BIODATA',
	'VISIT DETAILS',
	'ORPHAN’S PERSONALITY AND FAVORITES',
	'ORPHAN’S DETAILS',
	'HEALTH',
	'EDUCATION',
	'HOUSE DETAILS',
	'GENERAL STATEMENT',
	'ATTACHMENTS',
	'ID ATTACHMENTS',
	'PHOTOS & DOCS (SUMMER)',
	'PHOTOS & DOCS (WINTER)',
	'DOCUMENTS',
	'FORMS & EXCELS',
]
